import { render } from "./gridMenu.vue?vue&type=template&id=347e20de"
import script from "./gridMenu.vue?vue&type=script&lang=js"
export * from "./gridMenu.vue?vue&type=script&lang=js"

import "./gridMenu.vue?vue&type=style&index=0&id=347e20de&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__